import { resetTweak, setTweakValue, useTweakValue } from '@/lib/tweak-store';
import type { EnumDef } from '@mss_creator/shared';
import { OptionTiles } from './option-tiles';
import { SETTING_PREVIEWS } from './previews';
import { SettingRow } from './setting-row';

interface TweakTileRowProps {
  def: EnumDef;
  /** Current value of every tweak: a miniature may depend on another setting. */
  tweaks: Readonly<Record<string, string>>;
}

/**
 * One visual tweak as a row of option tiles. Applies on click (the tweak store
 * writes localStorage and the whole app re-renders), no save button. Each tile
 * carries the miniature registered for the tweak, drawn for that tile's option.
 */
export function TweakTileRow({ def, tweaks }: TweakTileRowProps) {
  const value = String(useTweakValue(def));
  const Preview = SETTING_PREVIEWS[def.key];
  return (
    <SettingRow
      label={def.label}
      description={def.description}
      modified={value !== def.default}
      onReset={() => resetTweak(def)}
    >
      <OptionTiles
        label={def.label}
        options={def.options}
        value={value}
        defaultValue={def.default}
        {...(Preview
          ? {
              renderPreview: (optionValue: string) => (
                <Preview value={optionValue} tweaks={tweaks} />
              ),
            }
          : {})}
        onChange={(next) => setTweakValue(def, next)}
      />
    </SettingRow>
  );
}
